export function parseLRC(lrcText) {
  const lines = lrcText.split('\n');
  const result = [];
  const timeRegex = /\[(\d{2}):(\d{2}\.\d{2,3})\](.*)/;
  
  for (let i = 0; i < lines.length; i++) {
    const match = lines[i].match(timeRegex);
    if (match) {
      const minutes = parseInt(match[1], 10);
      const seconds = parseFloat(match[2]);
      const text = match[3].trim();
      
      if (!text) continue; // skip empty lines

      const time = minutes * 60 + seconds;
      result.push({ start: time, text, words: text.split(/\s+/) });
    }
  }
  
  // Calculate end times based on next line
  for (let i = 0; i < result.length - 1; i++) {
    result[i].end = result[i+1].start;
  }
  if (result.length > 0) {
    result[result.length - 1].end = result[result.length - 1].start + 5; // guess 5 seconds for last line
  }
  
  // Distribute word timings evenly for karaoke highlight effect
  result.forEach(line => {
    const duration = line.end - line.start;
    const wordDur = duration / Math.max(1, line.words.length);
    line.words = line.words.map((w, idx) => ({
      text: w,
      start: line.start + idx * wordDur,
      end: line.start + (idx + 1) * wordDur
    }));
    line.id = Math.random().toString(36).substring(2, 9);
  });
  
  return result;
}